import { render, staticRenderFns } from "./AssetsVehiclesNewMileageForm.vue?vue&type=template&id=c2dd6b40&"
import script from "./AssetsVehiclesNewMileageForm.vue?vue&type=script&lang=js&"
export * from "./AssetsVehiclesNewMileageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports